import cuid from "cuid";
import { get } from "lodash";

export const resolveFirstProcessStatus = (process) => {
  const statuses = get(process, "processStatuses", []);
  if (!statuses.length) return null;
  return statuses.reduce((previous, current) =>
    Number(previous?.order) < Number(current.order) ? previous : current,
  );
};

/** The `addProject` payload of a project an advisor opens from a tracer. */
export const buildNewProjectData = ({ tracer, userId }) => {
  const status = resolveFirstProcessStatus(get(tracer, "flow.process"));
  return {
    visible: false,
    id: cuid(),
    statuses: [{ id: cuid(), status: { id: get(status, "id") } }],
    author: { id: userId },
    hasResponsible: true,
    tracer: { id: get(tracer, "id") },
    fields: { processTemplate: get(tracer, "flow.process.theme") },
  };
};
